import axios from "axios";
import { getHeaders } from "services/AuthHeader";
import { ResponseError } from "types/responses/ResponseError";

const API_URL = process.env.REACT_APP_API_URL;

export async function ResetPasswordService(password: string) {
    try {
        
        let search_params = new URLSearchParams(window.location.search)
        if (!search_params.has('reset_password')) {
            return 'general_error'
        }
        // const reset_password = new URLSearchParams(window.location.search).get("reset_password");
        // console.log("reset password Service".toUpperCase());
        // console.log("reset_password");
        
        const reset_password  = search_params.get('reset_password')
        // console.log(reset_password);
        
        const response = await axios.post(
            API_URL + '/reset_password',
            {
                password: password,
                hash: reset_password  
            }, {
                headers: getHeaders()
            }
        )
        
        if ("error" in response.data) {
            return response.data.error
        }
        if ("user" in response.data) {
            return response.data.user            
        }

    } catch (error) {
        return ResponseError.general_error
    }
}